import { APICore } from './apiCore'

const api = new APICore()

function getQuestionTypeOpinometros (params) {
  const baseUrl = '/question-type-opinometro'
  return api.get(baseUrl, params)
}

function getQuestionTypeOpinometro (id) {
  const baseUrl = `/question-type-opinometro/${id}`
  return api.get(baseUrl, {})
}

function addQuestionTypeOpinometro (params) {
  const baseUrl = '/question-type-opinometro'
  return api.create(baseUrl, params)
}

function updateQuestionTypeOpinometro (params) {
  const baseUrl = '/question-type-opinometro'
  return api.update(baseUrl, params)
}

function deleteQuestionTypeOpinometro (params) {
  const baseUrl = '/question-type-opinometro'
  return api.delete(baseUrl, params)
}

export { getQuestionTypeOpinometros, getQuestionTypeOpinometro, addQuestionTypeOpinometro, updateQuestionTypeOpinometro, deleteQuestionTypeOpinometro }
